import { uploadFiles } from "api/uploadApi";
import { CONFIG_OPTION_TOAST_ERROR } from "common/toast";
import { t } from "i18next";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { toast } from "react-toastify";
import { Input } from "reactstrap";

interface UploadFileProps {
    formik: any,
    fieldValue: string,
    isMultiple: boolean,
    acceptFile?: string,
    isUploadMore?: boolean,
    isDisabled?: boolean,
    maxFile?: number,
    setLinkImage?: any,
};

const UploadFileBK = ({
    formik,
    fieldValue = 'files',
    isMultiple = true,
    acceptFile = "image/jpeg, image/png, image/gif, image/webp", // "video/mp4,video/x-m4v,video/*,image/png,image/jpeg,image/*",
    isUploadMore = true,
    isDisabled = false,
    setLinkImage,
}: UploadFileProps) => {
    const [isLoading, setIsLoading] = useState(false);
    const fileInputRef = useRef<HTMLInputElement>(null);

    const values = useMemo(() => {
        return formik?.values ? formik?.values?.[`${fieldValue}`] : [];
    }, [formik?.values, fieldValue]);

    const handleChangeFile = async (event: React.ChangeEvent<HTMLInputElement>) => {
        setIsLoading(true)
        try {
            const files = event.target.files;
            if (files && files.length > 0) {
                const fileArray = Array.from(files);
                const resUpload = await uploadFiles(files);
                if(resUpload?.data) {
                    let formatRes = resUpload?.data?.map((item: any) => ({
                        url: item?.url,
                        thumbnailUrl: item?.relativePath,
                        name: item?.fileName,
                        type: item?.contentType.includes("video")
                          ? "video"
                          : "image",
                    }));
                    
                    formik && formik.setFieldValue(`${fieldValue}`, [...(values || []), ...formatRes]);
                }
                // formik && formik.setFieldValue(`${fieldValue}`, [...(values || []), ...fileArray]);
                if (fileInputRef.current) {
                    fileInputRef.current.value = ""; // Xóa giá trị của input
                }
            }
        }catch (error) {
            toast(`${error || ""}`, CONFIG_OPTION_TOAST_ERROR);
            return error;
        }finally {
            setIsLoading(false)
        }
    };

    const handleDeleteFile = (index: number) => {
        if (isDisabled) {
            return;
        }
        const fileArray = values?.filter((f: any, i: number) => i !== index);
        formik && formik.setFieldValue(`${fieldValue}`, fileArray);
    }

    const formatPositionPreviewImage = (
        files: any,
        activeImage: any,
    ) => {
        const filesFormat = files?.filter((item: any) =>item?.url !== activeImage?.url);

        const data = [activeImage, ...filesFormat];
        return data;
    };

    return (
        <React.Fragment>
            <>
                <div className="d-flex gap-3 flex-wrap">
                    {(values?.length > 0) && values?.map((_value: any, index: number) => {
                        const url = _value?.url ? _value?.url : (_value && _value);
                        return (
                            <div className="position-relative" key={index} style={{ width: '160px', height: '160px', backgroundColor: '#eaeaea', overflow: 'hidden', borderRadius: 'var(--vz-border-radius)' }}>
                                <img
                                    className="cursor-pointer"
                                    src={url}
                                    alt={`preview-${index + 1}`}
                                    style={{ width: "100%", height: "100%", objectFit: 'cover' }}
                                    onClick={() => {
                                        if (values?.length > 1) {
                                            const urls = formatPositionPreviewImage(values, _value);
                                            setLinkImage && setLinkImage({ urls: urls });
                                        } else {
                                            setLinkImage && setLinkImage({ url: url });
                                        }
                                    }}
                                />
                                <button type="button" className="position-absolute btn btn-sm btn-soft-danger edit-item-btn"
                                    style={{
                                        top: '10px',
                                        right: '10px',
                                        width: '30px',
                                        height: '30px',
                                        borderRadius: '15px',
                                    }}
                                    onClick={() => handleDeleteFile(index)}
                                ><i className="ri-delete-bin-3-fill align-bottom"></i></button>
                            </div>
                        )
                    })}
                    {(!!isUploadMore) && <div className={`custom-file-image-button z-0`}>
                        <Input
                            className="form-control"
                            accept={acceptFile}
                            label="Upload Your Image"
                            data-title="Upload Your Image"
                            id="formSizeDefault"
                            type="file"
                            multiple={isMultiple}
                            disabled={isDisabled}
                            onChange={handleChangeFile}
                            innerRef={fileInputRef}
                        />
                        {<div className="text-upload" style={{ zIndex: 1 }}>  <i className="ri-upload-line me-2" /> {values?.length ? t('Add Image') : t('No file chosen')}</div>}
                    </div>}
                </div>
            </>
        </React.Fragment>
    );
};

export default UploadFileBK;
